module.exports = __webpack_public_path__ + "assets/img/ggw1.5e649971.png";